import { BaseState } from '@/store/base-state';
import { default_certs, default_filters } from '@/components/widgets/services';
import { Widgets, WidgetFilters } from '../types';

export default class WidgetsState extends BaseState {
  widgets: Widgets.Widget = {
    orders: null,
    leads: null,
    software_licenses: null,
    certs: default_certs(),
    returns_zip: null,
    order_sides: null,
    repair_types: null,
    repair_models: null,
    atol_connect: null,
    clients_sigma: null,
    compensation_amounts: null,
    place_amounts: null,
    plane_fact: null,
    result_activity: null,
    result_service_activity: null,
    credit_line: null,
    retro_bonuses: null,
    limit_not_resident: null,
  };

  filters: WidgetFilters = default_filters();
  section = '';

  notification_widget_tab_model = 0;
}
